// extracted by mini-css-extract-plugin
export var proflink = "top-module--proflink--14ioF";
export var proflink_box = "top-module--proflink_box--3WsVp";
export var proflink_text = "top-module--proflink_text--9FlBc";
export var proflink_big = "top-module--proflink_big--3iDYh";
export var siteInfo = "top-module--site-info--1GZW9";